import {useInfiniteQuery} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {SubscriptionTransaction} from "@/model/transaction/subscriptionTransaction";
import subscriptionTransactionRepository from "../../repository/SubscriptionTransactionRepository";
import {Page} from "@/query";

const getData = async (
    pageable: {
        skip: number,
        limit: number,
    },
    workspaceName?: string,
    planName?: string,
    startDate?: string,
    endDate?: string,
) => {
    try {
        const { data } = await subscriptionTransactionRepository.find(
            workspaceName,
            planName,
            startDate,
            endDate,
            pageable.skip,
            pageable.limit
        );

        return {
            content: data.result,
            pageable: {
                ...pageable,
                isLast: data.result.length < pageable.limit
            }
        }
    } catch (e) {
        throw e;
    }
}

const useSubscriptionTransactions = (
    workspaceName?: string,
    planName?: string,
    startDate?: string,
    endDate?: string,
) => {
    return useInfiniteQuery<Page<SubscriptionTransaction>, AxiosError>({
        queryKey: ["subscription-transactions", workspaceName, planName, startDate, endDate],
        queryFn: async ({ pageParam = { skip: 0, limit: 20, isLast: false }}) => getData(
            pageParam,
            workspaceName,
            planName,
            startDate,
            endDate,
        ),
        retry: false,
        suspense: false,
        getNextPageParam: ({ pageable, content }) => {
            if (pageable.isLast) {
                return undefined
            }

            return {
                skip: pageable.skip + content.length,
                limit: pageable.limit,
                isLast: false
            }
        }
    })
}

export default useSubscriptionTransactions;
